import { render, staticRenderFns } from "./ChipsInput.vue?vue&type=template&id=27a950f3"
import script from "./ChipsInput.vue?vue&type=script&lang=js"
export * from "./ChipsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports